module.exports = __webpack_public_path__ + "static/img/gjfw1 (1).8c6ebd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/gjfw1 (1).png
// module id = 49CA
// module chunks = 64